function ShowSalesController(Auth, SingleTicket, $state, $filter, $window, PageHeading, $stateParams ) {
	'ngInject';

	const vm = this;
	vm.singleTicket = SingleTicket;
	vm.printWindow = printWindow;
	vm.params = $stateParams.params;
	vm.page = $stateParams.page;
	vm.hasPermission = Auth.getCurrentUser().roles[0].name === 'agent' ? false : true;
	
	activate();

	/** */
	function activate() {
		const heading = $filter('translate')('HEADING.PRINT_TICKET');
		const title = `BTMS | ${$filter('translate')('HEADING.PRINT_TICKET')}`;

		PageHeading.setPageHeading(heading, title);
	}

	/** */
	function printWindow() {
		$window.print();
	}
}

export default ShowSalesController;



/** WEBPACK FOOTER **
 ** ./client/private/sales/show/show.controller.js
 **/